export const NUMBER_FORMAT_LOCALE = "en-GB";

const WHOLE_NUMBER_FORMATTER = new Intl.NumberFormat(NUMBER_FORMAT_LOCALE, {
  useGrouping: true,
  maximumFractionDigits: 0,
});

export const formatWholeNumberWithGrouping = (
  value: number | string
): string => {
  const normalizedValue =
    typeof value === "number" ? value : Number(value || 0);
  return WHOLE_NUMBER_FORMATTER.format(normalizedValue);
};

export const formatNumberWithGrouping = (
  value: number,
  options?: Intl.NumberFormatOptions
): string => {
  return new Intl.NumberFormat(NUMBER_FORMAT_LOCALE, options).format(value);
};
